import { useQuery } from "@apollo/client";
import { AutocompleteElement } from "react-hook-form-mui";
import { useTranslation } from "react-i18next";

import { SettingsFunctionTypeEditRoute_ObservationTypeGetAllAssignableDocument } from "../../queries.generated";

type Props = {
    researchTypeId: string;
    ecologicalFunctionTypeId: string;
};

export default function FunctionTypeObservationTypeSelectElement({ researchTypeId, ecologicalFunctionTypeId }: Props) {
    const { t } = useTranslation("functionType");

    const { data, loading } = useQuery(SettingsFunctionTypeEditRoute_ObservationTypeGetAllAssignableDocument, {
        variables: { researchTypeId, ecologicalFunctionTypeId },
    });

    const options = data?.settingsObservationTypeGetAllAssignable.map(ft => ({ label: ft.name, id: ft.id })) ?? [];

    return (
        <AutocompleteElement
            name="observationTypeId"
            label={t("functionTypeObservationTypeSelectElement.labelAddObservationType")}
            loading={loading}
            options={options}
            matchId
        />
    );
}
